import { render, staticRenderFns } from "./ConfirmColleges.vue?vue&type=template&id=0287d5a4&scoped=true&"
import script from "./ConfirmColleges.vue?vue&type=script&lang=js&"
export * from "./ConfirmColleges.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmColleges.vue?vue&type=style&index=0&id=0287d5a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0287d5a4",
  null
  
)

export default component.exports